import React, { Component } from 'react';
import Loader from "../utils/Loader";
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { withRouter } from '../utils/withRouter';
import { connect } from "react-redux";
import { BASE_URL, toastError } from '../utils/constants';
import { getCmsContent_action } from '../actions/cms_action/cmsAction';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            scrollPosition: 0,
            cmsMode: '',
            headerNavs: [],
            UserID: localStorage.getItem("UserID"),
            RoleID: localStorage.getItem("RoleID"),
            cmsSubheaderData: [],
            govtLogoList: [],
            downloadUrl: '',
            overflowItems: []
        };
        this.onLogout = this.onLogout.bind(this);
        this.navLogin = this.navLogin.bind(this);
        this.handleMenuOverflow = this.handleMenuOverflow.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.toggleMobileSubmenu = this.toggleMobileSubmenu.bind(this);
    }

    componentDidMount() {
        const css = `
            /* Desktop More Menu */
            #moreMenu .sub-menu .menu-item-has-children > .sub-menu,
            #moreMenu .menu-item-has-children > .sub-menu {
                left: auto !important; right: 100% !important; top: 0 !important;
            }
            #moreMenu .menu-item-has-children > a::after { transform: rotate(360deg); }
            #moreMenu { z-index: 9999; }
            #moreMenu .sub-menu { min-width: 200px; }

            /* Mobile Menu Styles */
            .tgmobile__menu .navigation li {
                position: relative;
                border-bottom: 1px solid rgba(0,0,0,0.05);
            }
            .tgmobile__menu .navigation li > a {
                display: block;
                padding: 12px 0;
                font-size: 15px;
                color: white;
                font-weight: 500;
                text-transform: capitalize;
                cursor: pointer;
            }
            .tgmobile__menu .navigation li .sub-menu {
                display: none;
                padding-left: 20px;
                background: black;
            }
            .tgmobile__menu .navigation li .sub-menu.open {
                display: block;
            }
            
            /* Accordion Button Styles */
            .tgmobile__menu .dropdown-btn {
                position: absolute;
                top: 6px;
                right: 0;
                width: 32px;
                height: 32px;
                background: #f5f5f5;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
                border-radius: 4px;
                transition: all 0.3s;
                z-index: 5;
            }
            .tgmobile__menu .dropdown-btn .plus-line {
                position: relative;
                display: block;
                width: 10px;
                height: 2px;
                background: #151319;
                top: 15px;
                left: 11px;
                transition: all 0.3s;
            }
            .tgmobile__menu .dropdown-btn .plus-line::after {
                content: '';
                position: absolute;
                width: 2px;
                height: 10px;
                background: #151319;
                top: -4px;
                left: 4px;
                transition: all 0.3s;
            }
            .tgmobile__menu .dropdown-btn.open {
                background: #116469;
            }
            .tgmobile__menu .dropdown-btn.open .plus-line {
                background: #fff;
                transform: rotate(180deg);
            }
            .tgmobile__menu .dropdown-btn.open .plus-line::after {
                display: none;
            }
        `;
        this.styleEl = document.createElement('style');
        this.styleEl.type = 'text/css';
        this.styleEl.appendChild(document.createTextNode(css));
        document.head.appendChild(this.styleEl);

        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

        this.handleScroll = () => {
            this.setState({ scrollPosition: window.scrollY });
        };

        if (Array.isArray(this.props.headerNavs) && this.props.headerNavs.length > 0) {
            this.setState({ headerNavs: this.props.headerNavs }, () => {
                this.handleMenuOverflow();
            });
        } else {
            this.getCmsContent(1, 'home');
        }

        const path = this.props.location.pathname;
        const cmsPrefix = '/cms';
        if (path.includes(cmsPrefix)) {
            this.setState({ cmsMode: 1 })
        } else {
            this.setState({ cmsMode: 0 })
        }

        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener("resize", this.handleMenuOverflow);

        // Initialize mobile menu handlers
        this.initMobileMenuHandlers();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.headerNavs !== this.state.headerNavs || prevState.cmsMode !== this.state.cmsMode) {
            setTimeout(() => {
                this.handleMenuOverflow();
            }, 50);
        }

        if (this.props.headerNavs !== prevProps.headerNavs && Array.isArray(this.props.headerNavs)) {
            this.setState({ headerNavs: this.props.headerNavs });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("resize", this.handleMenuOverflow);
        if (this.styleEl && this.styleEl.parentNode) this.styleEl.parentNode.removeChild(this.styleEl);
    }

    initMobileMenuHandlers() {
        const toggler = document.querySelector(".mobile-nav-toggler");
        if (toggler) {
            toggler.onclick = (e) => {
                e.preventDefault();
                document.body.classList.add("mobile-menu-visible");
            };
        }
    }
    closeMobileMenu() {
        document.querySelectorAll(".tgmobile__menu-backdrop, .tgmobile__menu .close-btn").forEach(el => {
            el.onclick = () => document.body.classList.remove("mobile-menu-visible");
        });

    }
    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });
            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    headerNavs: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                    govtLogoList: data?.data[6] !== "" ? data?.data[6] : [],
                }, () => {
                    setTimeout(() => {
                        this.handleMenuOverflow();
                    }, 50);
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleMenuOverflow = () => {
        const nav = document.getElementById("mainMenu");
        if (!nav) return;
        const moreMenu = document.getElementById("moreMenu");
        const items = [...nav.children].filter(li => li.id !== "moreMenu");
        moreMenu.classList.add("d-none");
        let overflowItems = [];
        items.forEach(li => li.classList.remove("d-none"));
        let navWidth = nav.offsetWidth - 120;
        let totalWidth = 0;
        items.forEach(li => {
            const id = li.getAttribute("data-id");
            totalWidth += li.offsetWidth;
            if (totalWidth > navWidth) {
                moreMenu.classList.remove("d-none");
                if (id) overflowItems.push(id);
                li.classList.add("d-none");
            }
        });
        const cmsEnabled = localStorage.getItem("isVerified");
        const internalPagesExist = this.state.headerNavs.some(n => !n.isMenuItem);
        if (cmsEnabled) {
            if (internalPagesExist) {
                if (!overflowItems.includes("internal-pages")) overflowItems.push("internal-pages");
            }
            if (!overflowItems.includes("cms-root")) overflowItems.push("cms-root");
        }
        this.setState({ overflowItems: [...new Set(overflowItems)] });
    };

    onLogout() {
        localStorage.clear();
        this.props.navigate('/');
    }

    navLogin() {
        sessionStorage.setItem('isLoginClicked', true);
        this.props.navigate('/login');
    }

    handleMenuClick(MenuID, Url, Title) {
        document.body.classList.remove("mobile-menu-visible");

        if (Title === 'Visitor Registration') return;

        localStorage.setItem("MenuID", MenuID);
        localStorage.setItem("Url", Url);

        const trimmedUrl = (Url || '').trim();
        const externalUrlPattern = /^(https?:\/\/|www\.|ftp:\/\/|mailto:)/i;

        if (externalUrlPattern.test(trimmedUrl)) {
            window.open(trimmedUrl, '_blank');
        } else {
            const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl : '/' + trimmedUrl;
            const basePath = this.props.location.pathname.includes('/cms') ? '/cms/manage' : '';
            const newPath = `${basePath}${normalizedUrl}&${MenuID}`;
            this.props.navigate(newPath);
        }
    }

    toggleMobileSubmenu(e) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.currentTarget;
        const submenu = button.previousElementSibling;

        button.classList.toggle('open');
        if (submenu) {
            submenu.classList.toggle('open');
        }
    }

    renderMobileMenu() {
        const { headerNavs, cmsMode } = this.state;

        const internalPages = [];
        const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish) || [];
        const parents = filteredNavs?.filter(item => item.ParentID === null) || [];
        const childrenMap = {};

        filteredNavs?.forEach(item => {
            if (item.ParentID !== null) {
                if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                childrenMap[item.ParentID].push(item);
            }
        });

        const menuItems = parents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent) => {
            const hasChildren = (childrenMap[parent.MenuID] || []).length > 0;
            const showMenu = parent.isMenuItem || (hasChildren && (childrenMap[parent.MenuID] || []).some(child => child.isMenuItem));

            if (!showMenu && cmsMode) internalPages.push(parent);

            if (hasChildren) {
                return (
                    <li key={`mobile-${parent.MenuID}`} className="menu-item-has-children">
                        <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)}>
                            {parent.Title}
                        </a>
                        <ul className="sub-menu">
                            {childrenMap[parent.MenuID]?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => {
                                if (!child.isMenuItem && cmsMode) {
                                    internalPages.push(child);
                                    return null;
                                }
                                return (
                                    <li key={`mobile-child-${child.MenuID}`}>
                                        <a onClick={() => this.handleMenuClick(child.MenuID, child.Url, child.Title)}>
                                            {child.Title}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                        <div className="dropdown-btn" onClick={this.toggleMobileSubmenu}>
                            <span className="plus-line"></span>
                        </div>
                    </li>
                );
            }

            return showMenu ? (
                <li key={`mobile-${parent.MenuID}`}>
                    <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)}>
                        {parent.Title}
                    </a>
                </li>
            ) : null;
        });

        // Add Editor Home
        if (localStorage.getItem('isVerified')) {
            menuItems.unshift(
                <li key="mobile-editor-home">
                    <Link to="/cms/manage">Editor Home</Link>
                </li>
            );
        }

        // Add Internal Pages
        if (cmsMode && internalPages.length > 0) {
            menuItems.push(
                <li key="mobile-internal-pages" className="menu-item-has-children">
                    <a>Internal Pages</a>
                    <ul className="sub-menu">
                        {internalPages.map((item) => (
                            <li key={`mobile-internal-${item.MenuID}`}>
                                <a onClick={() => this.handleMenuClick(item.MenuID, item.Url, item.Title)}>
                                    {item.Title}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <div className="dropdown-btn" onClick={this.toggleMobileSubmenu}>
                        <span className="plus-line"></span>
                    </div>
                </li>
            );
        }

        // Add CMS Menu
        if (localStorage.getItem('isVerified')) {
            menuItems.push(
                <li key="mobile-cms-menu" className="menu-item-has-children">
                    <a>CMS</a>
                    <ul className="sub-menu">
                        <li><Link to="/cms/manage">Switch to Editor Mode</Link></li>
                        <li><Link to="/cms/header">Menu Settings</Link></li>
                        <li><a onClick={() => this.onLogout()}>Logout</a></li>
                    </ul>
                    <div className="dropdown-btn" onClick={this.toggleMobileSubmenu}>
                        <span className="plus-line"></span>
                    </div>
                </li>
            );
        }

        return menuItems;
    }

    render() {
        const { isLoading, headerNavs, cmsMode, cmsSubheaderData, govtLogoList, downloadUrl, overflowItems } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                <header>
                    {/* === Top Header === */}
                    <div className="tg-header__top d-none d-lg-block">
                        <div className="container custom-container">
                            <div className="row align-items-center">
                                {cmsSubheaderData?.length > 0 && (
                                    <>
                                        <div className="col-lg-4">
                                            <div className="tg-header__top-menu">
                                                <ul className="list-wrap mb-0">
                                                    {cmsSubheaderData
                                                        .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType === "SM")
                                                        .map(item => {
                                                            let iconClass = '';
                                                            let href = item.Link;
                                                            switch (item.SocialType) {
                                                                case 'Email': iconClass = 'fas fa-envelope'; href = `mailto:${item.Link}`; break;
                                                                case 'Phone': iconClass = 'fas fa-phone'; href = `tel:${item.Link}`; break;
                                                                case 'Instagram': iconClass = 'fab fa-instagram'; break;
                                                                case 'Facebook': iconClass = 'fab fa-facebook-f'; break;
                                                                case 'LinkedIn': iconClass = 'fab fa-linkedin-in'; break;
                                                                case 'Twitter': iconClass = 'fab fa-twitter'; break;
                                                                case 'Youtube': iconClass = 'fab fa-youtube'; break;
                                                                default: iconClass = '';
                                                            }
                                                            const isSpecialLink = href.startsWith('mailto:') || href.startsWith('tel:');
                                                            if (!isSpecialLink && !/^https?:\/\//i.test(href)) { href = `https://${href}`; }
                                                            return (
                                                                <li key={item.SubheaderID}>
                                                                    <a href={href} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2 flex-wrap flex-md-nowrap">
                                                                        {iconClass && <i className={`${iconClass}`} style={{ fontSize: "14px" }} />}
                                                                        <span style={{ fontSize: "10px" }}>{item.SubheaderName}</span>
                                                                    </a>
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="tg-header__top-social text-end">
                                                <marquee style={{ fontSize: "16px", color: "#fff", fontWeight: "500" }} behavior="scroll" direction="left" scrollamount="5" onMouseOver={(e) => e.target.stop()} onMouseOut={(e) => e.target.start()}>
                                                    <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website...
                                                </marquee>
                                            </div>
                                        </div>
                                        <div className="col-lg-2">
                                            <div className="tg-header__top-social text-end">
                                                {cmsSubheaderData
                                                    .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType == "BTN")
                                                    .map(item => (
                                                        <a key={item.SubheaderID} className="btn-blinker border mt-1 p-1 px-3 rounded-4 fw-normal d-inline-block me-2" href={item.Link} target="_blank" rel="noopener noreferrer" style={{ fontSize: "14px" }}>
                                                            {item.SubheaderName}
                                                        </a>
                                                    ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* === Sticky Header === */}
                    <div id="header-fixed-height" />

                    <div id="sticky-header" className="tg-header__area" style={{ padding: '10px 0', paddingTop: '10px' }}>
                        <div className="container custom-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="tgmenu__wrap">

                                        {/* Govt Logo (Desktop) */}
                                        {govtLogoList?.length && govtLogoList.filter((data) => data.isActive == 1 && data.isPublish == 1).length > 0 ? <>
                                            <div className="govt_logo text-end mb-2 d-none d-lg-flex justify-content-end align-items-center">
                                                {govtLogoList.length > 0 ? 'Supported By' : ''}
                                                {govtLogoList?.length > 0 && govtLogoList.filter((data) => data.isActive == 1 && data.isPublish == 1).map((logo, index) => {
                                                    const imgSrc = logo.GovtLogoFilepath ? `${downloadUrl}/${logo.GovtLogoFilepath.replace(/\\/g, "/")}` : "https://via.placeholder.com/150x80?text=Logo";
                                                    const imgElement = <img key={index} src={imgSrc} alt="Govt Logo" style={{ height: "40px", marginLeft: "10px" }} />;
                                                    return logo.Link ? <a key={index} target="_blank" href={logo.Link} rel="noopener noreferrer">{imgElement}</a> : imgElement;
                                                })}
                                            </div>
                                        </> : <></>}

                                        <nav className="tgmenu__nav container-fluid p-0">
                                            <div className="row align-items-center justify-content-between flex-nowrap">

                                                {/* 1. LOGO */}
                                                <div className="col-6 col-lg-2 d-flex justify-content-start">
                                                    <div className="logo">
                                                        <Link to="/">
                                                            <img src="assets/img/logo_2.png" alt="Logo" style={{ maxHeight: '50px' }} />
                                                        </Link>
                                                    </div>
                                                </div>

                                                {/* 2. DESKTOP MENU (Hidden on Mobile) */}
                                                <div className="col d-none d-lg-block">
                                                    <div className="tgmenu__navbar-wrap tgmenu__main-menu d-flex justify-content-center">
                                                        <ul className="navigation d-flex align-items-center justify-content-center gap-1 flex-nowrap" id="mainMenu">
                                                            {/* Editor Home */}
                                                            {localStorage.getItem('isVerified') && (
                                                                <li key={'editor-home'} data-id={'editor-home'}>
                                                                    <a style={{ fontSize: '13px' }}><Link to="/cms/manage">Editor Home</Link></a>
                                                                </li>
                                                            )}

                                                            {/* Dynamic Menu */}
                                                            {(() => {
                                                                const internalPages = [];
                                                                const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish) || [];
                                                                const parents = filteredNavs?.filter(item => item.ParentID === null) || [];
                                                                const childrenMap = {};
                                                                filteredNavs?.forEach(item => {
                                                                    if (item.ParentID !== null) {
                                                                        if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                                                                        childrenMap[item.ParentID].push(item);
                                                                    }
                                                                });
                                                                const menuItems = parents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent) => {
                                                                    const hasChildren = (childrenMap[parent.MenuID] || []).length > 0;
                                                                    const showMenu = parent.isMenuItem || (hasChildren && (childrenMap[parent.MenuID] || []).some(child => child.isMenuItem));
                                                                    if (!showMenu && cmsMode) internalPages.push(parent);
                                                                    if (hasChildren) {
                                                                        return (
                                                                            <li key={parent.MenuID} data-id={parent.MenuID} className="menu-item-has-children for-cms">
                                                                                <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)} style={{ fontSize: '13px', cursor: 'pointer' }}>{parent.Title}</a>
                                                                                <ul className="sub-menu">
                                                                                    {childrenMap[parent.MenuID]?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => {
                                                                                        if (!child.isMenuItem && cmsMode) { internalPages.push(child); return null; }
                                                                                        return (
                                                                                            <li key={child.MenuID} data-id={child.MenuID} className={`${(child.Title == 'Visitor Registration') ? 'visitor_header_footer_click' : ''}`}>
                                                                                                <a onClick={() => this.handleMenuClick(child.MenuID, child.Url, child.Title)} style={{ fontSize: '13px', cursor: 'pointer' }}>{child.Title}</a>
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </ul>
                                                                            </li>
                                                                        );
                                                                    }
                                                                    return showMenu ? (
                                                                        <li key={parent.MenuID} data-id={parent.MenuID}>
                                                                            <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)} style={{ fontSize: '13px', cursor: 'pointer' }}>{parent.Title}</a>
                                                                        </li>
                                                                    ) : null;
                                                                });
                                                                if (cmsMode && internalPages.length > 0) {
                                                                    menuItems.push(
                                                                        <li key="internal-pages" data-id="internal-pages" className="menu-item-has-children for-cms">
                                                                            <a style={{ fontSize: '13px' }}>Internal Pages</a>
                                                                            <ul className="sub-menu">
                                                                                {internalPages.map((item) => (
                                                                                    <li key={item.MenuID} data-id={item.MenuID}>
                                                                                        <a onClick={() => this.handleMenuClick(item.MenuID, item.Url, item.Title)} style={{ fontSize: '13px', cursor: 'pointer' }}>{item.Title}</a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </li>
                                                                    );
                                                                }
                                                                return menuItems;
                                                            })()}

                                                            {/* CMS Menu */}
                                                            {localStorage.getItem('isVerified') && (
                                                                <li key={'cms-menu'} data-id={'cms-root'} className="menu-item-has-children for-cms">
                                                                    <a style={{ fontSize: '13px' }}>CMS</a>
                                                                    <ul className="sub-menu">
                                                                        <li data-id="cms-manage"><Link to="/cms/manage">Switch to Editor Mode</Link></li>
                                                                        <li data-id="cms-header"><Link to="/cms/header">Menu Settings</Link></li>
                                                                        <li data-id="cms-logout" onClick={() => this.onLogout()}><a style={{ cursor: 'pointer' }}>Logout</a></li>
                                                                    </ul>
                                                                </li>
                                                            )}

                                                            {/* More Menu */}
                                                            <li id="moreMenu" className={`menu-item-has-children ${overflowItems && overflowItems.length ? '' : 'd-none'}`}>
                                                                <a style={{ fontSize: "13px" }}>More</a>
                                                                <ul className="sub-menu">
                                                                    {overflowItems.map(id => {
                                                                        const item = headerNavs?.find(x => x.MenuID == id) || null;
                                                                        if (id === 'cms-root') return <li key="cms-root" className="menu-item-has-children left-side" data-id="cms-root"><a style={{ fontSize: "13px" }}>CMS</a><ul className="sub-menu sub-left"><li data-id="cms-manage"><Link to="/cms/manage">Switch to Editor Mode</Link></li><li data-id="cms-logout" onClick={() => this.onLogout()}><a style={{ cursor: 'pointer' }}>Logout</a></li></ul></li>;

                                                                        if (item) return <li key={`more-${id}`} data-id={item.MenuID}><a onClick={() => this.handleMenuClick(item.MenuID, item.Url, item.Title)} style={{ fontSize: "13px", cursor: 'pointer' }}>{item.Title}</a></li>;
                                                                        return null;
                                                                    })}
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* 3. RIGHT ACTIONS (Login + Hamburger) */}
                                                <div className="col-6 col-lg-2 d-flex justify-content-end align-items-center">
                                                    <div className="tgmenu__action d-flex align-items-center">
                                                        <ul className="list-wrap m-0 d-flex align-items-center">
                                                            <li>
                                                                <a href="https://india-itme.com/" target="_blank"
                                                                    className="btn border-btn my_login_btn login_btn_click"
                                                                    style={{ padding: '8px 15px', fontSize: '13px', whiteSpace: 'nowrap' }}>
                                                                    Login
                                                                </a>
                                                            </li>
                                                        </ul>

                                                        {/* Hamburger (Mobile Only) */}
                                                        <div className="mobile-nav-toggler ms-3 d-lg-none" style={{ cursor: 'pointer', fontSize: '24px' }}>
                                                            <i className="fas fa-bars"></i>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* === MOBILE MENU SIDEBAR === */}
                    <div className="tgmobile__menu">
                        <nav className="tgmobile__menu-box">
                            <div className="close-btn" onClick={() => this.closeMobileMenu()}><i className="fas fa-times"></i></div>
                            <div className="nav-logo">
                                <Link to="/"><img src="assets/img/logo_2.png" alt="Logo" /></Link>
                            </div>
                            <div className="tgmobile__menu-outer">
                                <ul className="navigation">
                                    {this.renderMobileMenu()}
                                </ul>
                            </div>
                            <div className="social-links">
                                <ul className="list-wrap">
                                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </nav>
                    </div>

                </header>
            </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action })(Header));